import { SignInType } from '~constants/SignInTypeEnum';
import {
    SOCIAL_QUERY_CONNECT,
    SOCIAL_QUERY_DISCONNECT,
    SocialPageLoadType
} from '~constants/SocialConstants';

import { DisconnectSocialUseCase } from './DisconnectSocialUseCase';
import { SocialCallbackLoadedUseCase } from './SocialCallbackLoadedUseCase';
import { SocialSignInClickedUseCase } from './SocialSignInClickedUseCase';

export class SocialPageLoadedUseCase {
    private socialPageLoadType: SocialPageLoadType;
    constructor(socialPageLoadType: SocialPageLoadType) {
        this.socialPageLoadType = socialPageLoadType;
    }

    execute = async () => {
        const urlParams = new URLSearchParams(window.location.search);
        const useCase = (() => {
            switch (this.socialPageLoadType) {
                case SocialPageLoadType.DISCONNECT:
                    return new DisconnectSocialUseCase(
                        urlParams.get(SOCIAL_QUERY_DISCONNECT) as SignInType
                    );
                case SocialPageLoadType.STATE:
                    return new SocialCallbackLoadedUseCase();
                case SocialPageLoadType.CONNECT:
                    return new SocialSignInClickedUseCase(
                        urlParams.get(SOCIAL_QUERY_CONNECT) as SignInType
                    );
                default:
                    return new SocialCallbackLoadedUseCase();
            }
        })();

        await useCase.execute();
    };
}
